exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:SFPro-Regular;src:url(\"/fonts/SFPro/TrueType/SFProDisplay-Regular.ttf\")}.theme--light.v-application{font-family:SFPro-Regular}.v-btn{text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-629b4901","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/App.vue
// module id = yw1B
// module chunks = 1